import { defineStore } from 'pinia'
import type { IMultiselectOption } from '~/types'

export const useCardsFiltersStore = defineStore('cards-filters', {
  state: () => ({
    searchQueryString: '' as string,
    selectedCardType: [] as IMultiselectOption[],
    selectedCardCurrencyType: [] as IMultiselectOption[],
    selectedCardOption: [] as IMultiselectOption[],
    selectedCardSystems: [] as IMultiselectOption[],
    selectedCardBonuses: [] as IMultiselectOption[],
    selectedCardFeatures: [] as IMultiselectOption[],
    currency: [] as IMultiselectOption[],
    currentPage: 1 as number
  }),
  actions: {
    reset() {
      this.searchQueryString = ''
      this.selectedCardType = []
      this.selectedCardCurrencyType = []
      this.selectedCardOption = []
      this.selectedCardSystems = []
      this.selectedCardBonuses = []
      this.selectedCardFeatures = []
      this.currency = []
      this.currentPage = 1
    },
    apply() {
      this.currentPage = 1
    }
  }
})
